<script setup>
// NOTE: 앞으로 사용 X
import { computed } from "vue";

const props = defineProps({
  dialogValue: Boolean,
  persistent: Boolean,
  fullscreen: Boolean,
  hideOverlay: Boolean,
  maxWidth: String,
  dialogTransition: String,
  dialogCustom: String,
  cardElevation: String,
  title: String,
  titleClass: String,
  textClass: String,
  saveText: String,
  confirmText: String,
  closeText: String,
});

const emit = defineEmits(["update:dialogValue", "save", "confirm", "close"]);

// Compute a two-way binding for the v-model
const dialog = computed({
  get: () => props.dialogValue,
  set: (value) => emit("update:dialogValue", value),
});

const close = () => {
  emit("update:dialogValue", false);
  emit("close");
};

const save = () => {
  emit("save");
};

const confirm = () => {
  emit("confirm");
};
</script>

<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="fullscreen"
    :max-width="maxWidth || '500px'"
    :persistent="persistent"
    :transition="dialogTransition"
    :content-class="dialogCustom"
    :hide-overlay="hideOverlay"
    @click:outside="persistent ? null : close()"
  >
    <template #activator="{ on, attrs }">
      <slot
        name="activator"
        v-bind="attrs"
        v-on="on"
      ></slot>
    </template>

    <v-card
      ref="card"
      :elevation="cardElevation || '2'"
    >
      <v-card-title
        :class="titleClass || 'blue lighten-5 text-h6 font-weight-black'"
      >
        <span
          v-if="title"
          class="w-full block"
          >{{ title }}</span
        >
        <slot name="titleHTML"></slot>
      </v-card-title>

      <v-card-text :class="textClass">
        <slot></slot>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="saveText"
          color="blue darken-1"
          text
          @click="save"
          >{{ saveText }}</v-btn
        >
        <v-btn
          v-if="confirmText"
          color="blue darken-1"
          text
          @click="confirm"
          >{{ confirmText }}</v-btn
        >
        <v-btn
          v-if="closeText"
          color="blue darken-1"
          text
          @click="close"
          >{{ closeText }}</v-btn
        >
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
